import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default (props)=> <SvgIcon {...props} >
    <path d="M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z" />
    <text x="8" y="16" className="small" style={{   fontSize: "7px", fontWeight: "300"}}>15</text>
  </SvgIcon>